import { mapGetters } from 'vuex';
import { mapMutations } from 'vuex';

import ItemCheckout from './../../../classes/ItemCheckOut';
import { getPricesList, findPriceForPlayers, getPartialPrice, isOpenGroup, sessionInfo, privateSessionPrice } from './../../../helpers';

export default {
    props: ['schedule','calendar','experienceContent','currentDay','currentDayPlus','dateSelected','callSunday', 'call'],
    data() {
        return {
            scheduleSelected: false,
            scheduleDesktop: false,
            scheduleMobile: false,
            openModal: false,
        }
    },
    computed: {
        ...mapGetters(['getCheckout','getDesign','isMultiPrice','getPlayersSelected', 'getCalendarDays']),
        checkSchedule : function () {
            const checkDelayResponse = this.checkDelay();
            const checkPassDay = this.checkPassDay();
            const block = !this.call && checkDelayResponse || !this.checkFree();
            const isCalendarDayBlockedByBackend = this.isCalendarDayBlocked();
            
            return {
                'selected' : !checkPassDay && this.scheduleSelected,
                'call': this.call && !checkPassDay && checkDelayResponse,
                'free': !checkPassDay && this.checkFree() && !block,
                'block' : checkPassDay || block || isCalendarDayBlockedByBackend,
                'dark' : this.getDesign() == "black",
                'white' : this.getDesign() == "white"
            }
        },
        // Grupos abiertos: plazas que quedan en la sesion. En Ambos solo se ensena cuando ya se ha unido alguien.
        placesLeft: function () {
            if (!isOpenGroup(this.experienceContent) || !this.checkFree()) {
                return null;
            }
            const info = sessionInfo(this.experienceContent, this.schedule);
            if (!info.open_session || (info.private_available && info.free_places >= this.experienceContent.maxPlayers)) {
                return null;
            }

            return info.free_places;
        }
    },
    created() {
        this.checkDevice();
    },
    methods: {
        ...mapMutations(['addItem','removeItem']),
        checkDevice: function () {
            const toMatch = [
                /Android/i,
                /iPhone/i,
                /iPad/i,
                /iPod/i,
                /BlackBerry/i,
                /Windows Phone/i
            ];

            this.scheduleMobile = toMatch.some((toMatchItem) => {
                return navigator.userAgent.match(toMatchItem);
            });

            this.scheduleDesktop = !this.scheduleMobile;
        },
        checkDelay: function () {
            if(this.checkFree()) {
                this.currentDay = this.currentDay ?? new Date();
                const startSession = this.schedule.start_session.split(':');
                const dateSelected = this.dateSelected.split('/');
                const roomDate = new Date(dateSelected[2], dateSelected[1]-1, dateSelected[0], startSession[0], startSession[1], 0);

                return this.currentDay.getTime() <= roomDate.getTime() &&  this.currentDayPlus.getTime() >= roomDate.getTime();
            }
            else {
                return false;
            }
        },
        checkPassDay: function () {
            this.currentDay = this.currentDay ?? new Date();
            const startSession = this.schedule.start_session.split(':');
            const dateSelected = this.dateSelected.split('/');
            const roomDate = new Date(dateSelected[2], dateSelected[1]-1, dateSelected[0], startSession[0], startSession[1], 0);

            return roomDate.getTime() < this.currentDay.getTime();
        },
        checkPlayers: function(){
            const availableRooms = Math.ceil(this.getPlayersSelected() / this.experienceContent.maxPlayers);
            const schedules = this.experienceContent.calendars.map(cal => cal.schedules).flat(1);
            const currentSchedules = schedules.filter(s => s.start_session === this.schedule.start_session && s.isFree);

            return currentSchedules.length >= availableRooms;
        },
        checkFree: function(){
            return this.isMultiPrice() ? this.checkPlayers() : this.schedule.isFree;
        },
        selectSchedule: function (isBlock) {
            if(this.checkFree() && !isBlock) {
                let newFormatDateSplit = this.dateSelected.split('/');
                let newDate = newFormatDateSplit[2] + '-' + newFormatDateSplit[1].padStart(2, "0") + '-' + newFormatDateSplit[0];

                if(!this.isMultiPrice()){
                    this.createCheckout(newDate);
                }else{
                    this.createMultiPriceCheckout(newDate);
                }

                this.$emit('schedule-selected');
            }
        },
        getLanguage() {
            const field = this.experienceContent.fields.find(f => f.isLanguage)
            return field && field.options.length ? field.options[0].value : '';
        },
        getPrice(){
            const prices = getPricesList(this.experienceContent);
            let price = prices.length ? prices[0].full_price : 0;
            if(this.isMultiPrice()){
                // Sin tramo aplicable el precio se queda a 0 en vez de romper la seleccion de hora.
                const currentPrice = findPriceForPlayers(this.experienceContent, this.getPlayersSelected());
                price = (currentPrice ? currentPrice.full_price : 0) * this.getPlayersSelected();
            }

            return price;
        },
        createCheckout(newDate){
            const info = sessionInfo(this.experienceContent, this.schedule);
            // En una sesion abierta solo se puede elegir hasta las plazas que quedan.
            const prices = getPricesList(this.experienceContent)
                .filter(price => !info.open_session || price.people <= info.free_places);
            const privatePrice = info.open_session ? null : privateSessionPrice(this.experienceContent);
            let itemCheckout = new ItemCheckout(
                this.experienceContent.id,
                this.calendar,
                newDate + ' ' + this.schedule.start_session,
                this.schedule.start_session.slice(0,5),
                newDate + ' ' + this.schedule.end_session,
                this.schedule.end_session.slice(0,5),
                prices.length ? prices[0].people : this.experienceContent.minPlayers,
                this.experienceContent.groupType === 'mix' && privatePrice !== null ? privatePrice : (prices.length ? prices[0].full_price : this.getPrice()),
                getPartialPrice(this.experienceContent),
                this.getLanguage()
            );
            Object.assign(itemCheckout, info);

            this.scheduleSelected = !this.scheduleSelected;
            if(this.scheduleSelected) this.addItem({item: itemCheckout});
            else this.removeItem({item: itemCheckout});
        },
        createMultiPriceCheckout(newDate){
            const availableRooms = Math.ceil(this.getPlayersSelected() / this.experienceContent.maxPlayers);
            let currentPlayers = this.getPlayersSelected();
            const availableCalendars = this.experienceContent.calendars.filter(c => c.schedules.find(s => s.start_session === this.schedule.start_session && s.isFree));
            for(let i = 0; i < availableRooms; i++){
                currentPlayers = currentPlayers
                const itemCheckout = new ItemCheckout(
                    this.experienceContent.id,
                    availableCalendars[i].id,
                    newDate + ' ' + this.schedule.start_session,
                    this.schedule.start_session.slice(0,5),
                    newDate + ' ' + this.schedule.end_session,
                    this.schedule.end_session.slice(0,5),
                    currentPlayers > this.experienceContent.maxPlayers ? this.experienceContent.maxPlayers : currentPlayers,
                    i === 0 ? this.getPrice() : 0,
                    getPartialPrice(this.experienceContent),
                    this.getPlayersSelected(),
                    this.getLanguage()
                );

                currentPlayers -= this.experienceContent.maxPlayers;
                this.addItem({item: itemCheckout})
            }
        },
        isCalendarDayBlocked() {
            /*
            aora se tiene que ver en los dias disponibles del calendario para que tenga en cuenta que si ha
            sido bloqueado o no tenendo encuenta

            1. Caudno se bloquea por días especiales o por la propia experiencia el total es cero
            2. Cuando se bloquea por reservas > calendariios ocuppied >= total
            */

            try {
            const dayCalendar = this.getCalendarDays()[this.dateSelected];

            if(!dayCalendar) {
                return false;
            }
            
            return dayCalendar.total === 0 || dayCalendar.occupied >= dayCalendar.total;

            }catch(e) {
                return false;
            }
        }
    }
}